/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make sure exactly one field is empty and the other three contain valid numbers. If a solve would require dividing by zero, there is no valid result.`)
};

const es_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asegúrate de que exactamente un campo esté vacío y los otros tres contengan números válidos. Si el cálculo requiere dividir por cero, no hay un resultado válido.`)
};

const de_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen Sie sicher, dass genau ein Feld leer ist und die anderen drei gültige Zahlen enthalten. Wenn eine Lösung eine Division durch null erfordern würde, gibt es kein gültiges Ergebnis.`)
};

const nl_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zorg dat precies één veld leeg is en dat de andere drie geldige getallen bevatten. Als de berekening een deling door nul zou vereisen, is er geen geldige oplossing.`)
};

const fr_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assurez-vous qu'exactement un champ est vide et que les trois autres contiennent des nombres valides. Si la résolution nécessite une division par zéro, il n'y a pas de résultat valide.`)
};

const it_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assicurati che esattamente un campo sia vuoto e che gli altri tre contengano numeri validi. Se la soluzione richiederebbe una divisione per zero, non esiste un risultato valido.`)
};

const pt_br2_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique se exatamente um campo está vazio e os outros três contêm números válidos. Se a resolução exigir divisão por zero, não há resultado válido.`)
};

const pt_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certifique-se de que exatamente um campo está vazio e os outros três contêm números válidos. Se o cálculo exigir uma divisão por zero, não existe resultado válido.`)
};

const ja_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空欄がちょうど1つで、残り3つに有効な数値が入っているか確認してください。ゼロ除算が必要になる場合、有効な解はありません。`)
};

const zh_soldil_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请确保恰好一个字段为空，其余三个字段包含有效数字。如果求解需要除以零，则没有有效结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_faq_a4", locale)
	if (locale === "en") return en_soldil_faq_a4(inputs)
	if (locale === "es") return es_soldil_faq_a4(inputs)
	if (locale === "de") return de_soldil_faq_a4(inputs)
	if (locale === "nl") return nl_soldil_faq_a4(inputs)
	if (locale === "fr") return fr_soldil_faq_a4(inputs)
	if (locale === "it") return it_soldil_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_faq_a4(inputs)
	if (locale === "pt") return pt_soldil_faq_a4(inputs)
	if (locale === "ja") return ja_soldil_faq_a4(inputs)
	return zh_soldil_faq_a4(inputs)
};